import { render, staticRenderFns } from "./smart-diagnose-alert.vue?vue&type=template&id=3b455411&scoped=true"
import script from "./smart-diagnose-alert.vue?vue&type=script&lang=js"
export * from "./smart-diagnose-alert.vue?vue&type=script&lang=js"
import style0 from "./smart-diagnose-alert.vue?vue&type=style&index=0&id=3b455411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b455411",
  null
  
)

export default component.exports